import axios from "axios";
import Vue from "vue";

const LOGIN_PATH = "/accounts/admin/login/";

const API_V1 = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Accept-Language": "fa",
    },
});

API_V1.interceptors.request.use((config) => {
    const isLoginRequest = (config.url || "").includes(LOGIN_PATH);
    const token = localStorage.getItem("token");

    if (token && !isLoginRequest) {
        config.headers.Authorization = token;
    } else {
        delete config.headers.Authorization;
    }

    return config;
});

API_V1.interceptors.response.use(
    (response) => response,
    async function (error) {
        Vue.$toast.error(error);

        const status = error.response?.status;
        const isLoginRequest = (error.config?.url || "").includes(LOGIN_PATH);

        if (status === 401 && !isLoginRequest) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }

        return Promise.reject(error.response);
    },
);

export { API_V1 };
